import { useRef, useEffect, useState, useLayoutEffect } from 'react';
import ImageIcon from '../../../assets/svg/image.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJCreationPanel.module.less';
import PropTypes from 'prop-types';
import FJBlankPanel from '../FJBlankPanel/FJBlankPanel';
import FJTextToImagePresetItemContainer from '../../FJTextToImage/FJTextToImageRight/container/FJTextToImagePresetItemContainer';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJBlankInVideoPanel from '../FJBlankPanel/FJBlankInVideoPanel';
import classNames from 'classnames';
import FJVideoContent from '../../../common/components/FJVideoPlayer/FJVideoContent.jsx';
import videoBgBase64 from '../../../assets/base64/video-bg.js';
import FJAIVideoGeneratorBtnGroupContainer from '../../FJAIVideoGenerator/FJAIVideoGeneratorRight/container/FJAIVideoGeneratorBtnGroupContainer.jsx';
import FJSourcePreviewItem from '../FJSourcePreviewItem/FJSourcePreviewItem.jsx';

const IMAGE_SPACE = 18;
const FJCreationPanel = props => {
    const {
        appType,
        creationList,
        previewImage,
        onDownload,
        onAddToMedia,
        reGenerate,
        active,
        isShowPresetImageBox = false,
        hideCompare = false,
        hideDownload = false,
        isShowBlankInVideoPanel = false,
        isShowAddToMediaButton = false,
    } = props;
    const containerRef = useRef(null);
    const imgListRef = useRef([]);
    const boxRef = useRef(null);

    const [viewSize, setViewSize] = useState({ width: 0, height: 0 });
    const isVideoShowPreset = isShowPresetImageBox && FJAppConstant.AI_VIDEO_GENERATOR === appType;

    useLayoutEffect(() => {
        const _updateViewSize = () => {
            if (boxRef.current) {
                const viewRect = boxRef.current.getBoundingClientRect();
                setViewSize({
                    width: viewRect.width - 19 * 2,
                    height: viewRect.height - 100 - 66,
                });
            }
        };

        _updateViewSize();
        window.addEventListener('resize', _updateViewSize);
        return () => {
            window.removeEventListener('resize', _updateViewSize);
        };
    }, [boxRef.current]);

    useEffect(() => {
        if (!active) return;
        const _updateUI = () => {
            if (boxRef.current && creationList?.length) {
                const viewRect = boxRef.current.getBoundingClientRect();

                let viewWidth = viewRect.width - IMAGE_SPACE;
                let viewHeight = viewRect.height - 32 - IMAGE_SPACE;
                if (isShowPresetImageBox && FJAppConstant.AI_VIDEO_GENERATOR === appType) {
                    viewHeight = viewHeight - 150;
                    viewWidth = viewWidth - 80;
                }

                const { width: originWidth, height: originHeight } = creationList[0];
                const ratio = originWidth / originHeight;
                let imgW = 0;
                let imgH = 0;
                let padding = 0;
                if (creationList.length < 3) {
                    imgW = (viewWidth - IMAGE_SPACE * (creationList.length - 1)) / creationList.length;
                    imgH = imgW / ratio;
                    if (imgH > viewHeight) {
                        imgH = viewHeight;
                        imgW = imgH * ratio;
                    }
                } else {
                    let rowNum = 2;
                    let columnNum = Math.ceil(creationList.length / rowNum);
                    if (ratio >= 1) {
                        imgW = (viewWidth - IMAGE_SPACE * (columnNum - 1)) / columnNum;
                        imgH = imgW / ratio;
                        if (imgH * rowNum + IMAGE_SPACE * (rowNum - 1) > viewHeight) {
                            imgH = (viewHeight - IMAGE_SPACE * (rowNum - 1)) / rowNum;
                            imgW = imgH * ratio;
                        }
                    } else {
                        imgH = (viewHeight - IMAGE_SPACE * (rowNum - 1)) / rowNum;
                        imgW = imgH * ratio;
                        if (imgW * columnNum + IMAGE_SPACE * (columnNum - 1) > viewWidth) {
                            imgW = (viewWidth - IMAGE_SPACE * (columnNum - 1)) / columnNum;
                            imgH = imgW / ratio;
                        }
                    }
                    if (imgW * creationList.length + IMAGE_SPACE * (creationList.length - 1) <= viewWidth) {
                        rowNum = 1;
                        columnNum = Math.ceil(creationList.length / rowNum);
                        imgW = (viewWidth - IMAGE_SPACE * (columnNum - 1)) / columnNum;
                        imgH = imgW / ratio;
                        if (imgH > viewHeight) {
                            imgH = viewHeight;
                            imgW = imgH * ratio;
                        }
                    }
                    if (rowNum == 2) {
                        const containerWidth = viewWidth + IMAGE_SPACE;
                        const count = Math.ceil(creationList.length / rowNum);
                        padding = Math.floor((containerWidth - (imgW + IMAGE_SPACE) * count) / 2);
                    }
                }
                imgListRef.current.forEach(item => {
                    if (item) {
                        item.style.width = imgW + 'px';
                        item.style.height = imgH + 'px';
                    }
                });
                if (!isVideoShowPreset) {
                    containerRef.current.style.width = viewWidth + IMAGE_SPACE + 'px';
                    containerRef.current.style.height = viewHeight + IMAGE_SPACE + 'px';
                }
                containerRef.current.style.padding = ` 0 ${padding}px`;
            }
        };

        // TODO 在编辑页中会有一个缩放的动画导致获取尺寸不正确，所以加个延时
        if (window.isEditPage) {
            setTimeout(() => {
                _updateUI();
            }, 300);
        } else {
            _updateUI();
        }

        window.addEventListener('resize', _updateUI);
        return () => {
            window.removeEventListener('resize', _updateUI);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [creationList, active, isShowPresetImageBox, isVideoShowPreset, appType]);

    const renderItem = () => {
        if (isShowPresetImageBox) {
            return creationList.map((item, idx) => {
                return (
                    <div className={styles.img_box} key={idx} ref={ref => (imgListRef.current[idx] = ref)}>
                        <FJTextToImagePresetItemContainer presetData={item} />
                    </div>
                );
            });
        }
        if (FJAppConstant.AI_VIDEO_GENERATOR === appType) {
            const item = creationList[0];
            return (
                <div className={styles.video_box}>
                    <FJVideoContent
                        url={item.videoUrl}
                        isAutoPlay
                        viewSize={viewSize}
                        renderBottom={width => {
                            return <FJAIVideoGeneratorBtnGroupContainer width={width} />;
                        }}
                        isLoop={true}
                        scope='default'
                        ratio={item.ratio}
                        isKeySpace={false}
                    />
                </div>
            );
        }
        return creationList.map((item, idx) => {
            return (
                <div className={styles.img_box} key={item.type + item.id} ref={ref => (imgListRef.current[idx] = ref)}>
                    <FJSourcePreviewItem
                        appType={appType}
                        item={item}
                        onDownload={onDownload}
                        onAddToMedia={onAddToMedia}
                        reGenerate={reGenerate}
                        onClick={previewImage}
                        isShowSelected={false}
                        hideSelect={true}
                        hideDelete={true}
                        hideCompare={hideCompare}
                        hideDownload={hideDownload}
                        isShowAddToMediaButton={isShowAddToMediaButton}
                    />
                </div>
            );
        });
    };

    return (
        <div
            className={classNames(styles.content, {
                [styles.not_padding]: isShowBlankInVideoPanel && !creationList?.length,
                [styles.video_padding]: isVideoShowPreset,
            })}
            style={{ display: active ? (isVideoShowPreset ? 'flex' : 'block') : 'none' }}
            ref={boxRef}
        >
            {isShowPresetImageBox && FJAppConstant.AI_VIDEO_GENERATOR === appType && (
                <>
                    <div className={styles.cover_box}>
                        <img src={videoBgBase64} alt='' />
                    </div>
                    <div className={styles.title_main}>
                        {FJLocalStore._('turn-your-creative-ideas-into-reality-with-AI')}
                    </div>
                    <div className={styles.title_sub}>
                        {FJLocalStore._('easily-create-AI-videos-with-text-or-image-prompts')}
                    </div>
                </>
            )}
            {creationList?.length ? (
                <div className={styles.inner} ref={containerRef}>
                    {renderItem()}
                </div>
            ) : isShowBlankInVideoPanel ? (
                <FJBlankInVideoPanel active={active} />
            ) : (
                <FJBlankPanel
                    icon={<ImageIcon />}
                    text={
                        appType === FJAppConstant.IMAGE_EXTENDER
                            ? FJLocalStore._('no-results-yet')
                            : FJLocalStore._('no-creations-yet')
                    }
                />
            )}
        </div>
    );
};
FJCreationPanel.propTypes = {
    appType: PropTypes.string,
    creationList: PropTypes.array,
    previewImage: PropTypes.func,
    onAddToMedia: PropTypes.func,
    reGenerate: PropTypes.func,
    onDownload: PropTypes.func,
    active: PropTypes.bool,
    isShowPresetImageBox: PropTypes.bool,
    hideCompare: PropTypes.bool,
    hideDownload: PropTypes.bool,
    isShowBlankInVideoPanel: PropTypes.bool,
    isShowAddToMediaButton: PropTypes.bool,
};
export default FJCreationPanel;
